<div
  class="text-container"
  [class.disabled]="disabled"
  (click)="onContainerClick($event)"
  [style]="customStyles"
>
  <span
    [id]="spanId"
    class="text-box h-100"
    [ngClass]="{
      selected: (isEditing$ | async),
      error: (isTitleValid$ | async) === false,
      disabled: disabled
    }"
    [ngStyle]="disabled && { border: '1px solid transparent', background: 'transparent' }"
    [style.display]="
      (isEditing$ | async)
        ? spanEditingInlineFlex
          ? 'inline-flex'
          : 'inline'
        : customStyles
        ? 'flex'
        : 'block'
    "
    [attr.contenteditable]="!disabled"
    spellcheck="false"
    (keydown.enter)="textField.blur()"
    (keydown)="preventNewLine($event); $event.stopPropagation()"
    (keypress)="preventExceedMaxAllowedCharsLength($event)"
    (keyup)="checkValidTitle($event)"
    (blur)="onBlur(textField.innerText)"
    (click)="onClick($event)"
    (selectstart)="onSelect($event)"
    (paste)="handleTitlePaste($event)"
    (dragenter)="$event.preventDefault()"
    [appTooltip]="errorTooltipTemplate"
    [appTooltipPlacement]="'bottom-center'"
    [appTooltipTriggerType]="'manual'"
    [autoPositionArrow]="true"
    #errorTooltip="appTooltip"
    #textField
  >
    <ng-container *ngIf="isEditing$ | async; else viewState"> {{ mainText }} </ng-container>
    <ng-template #viewState>
      <ng-container *ngIf="truncateUsingWidth && maxWidth && font; else truncateByLength">
        {{ mainText | truncateByWidth: maxWidth:font }}
      </ng-container>
      <ng-template #truncateByLength>
        <ng-container *ngIf="truncateStringBy === undefined; else truncateText">
          {{ mainText | truncate: [25] }}
        </ng-container>
        <ng-template #truncateText>
          {{ mainText | truncate: [truncateStringBy] }}
        </ng-template>
      </ng-template>
    </ng-template>
  </span>
</div>

<ng-template #errorTooltipTemplate>
  <app-tooltip [arrow]="'top'" [text]="validationErrorMsg$ | async"></app-tooltip>
</ng-template>
